import IndexModule from "@api/IndexModule";
import "@css/public.css";
import "@css/web/common.css";
import "@css/web/search.css";
import "@js/imglazyloading.js";
import { getVal, letterLight, throttle, toDateList, includeTest } from "@utils/utils.js";

let query = getVal(window.location.href)
let searchAfter = ''
//input的搜索词
$('#seaerch_val').val(decodeURIComponent(query))
//搜索
$(".seaerch_sea").click(function () {
  showTest()
})
$(function(){
  // 按下回车
  $("#seaerch_val").keydown(function (event) {
    if (event.keyCode == 13) {
      showTest()
    }  
  });
})
function showTest(){
  query =$('#seaerch_val').val();
  // 判断是否包含特殊字符
  if(includeTest(query)){
    $('.text-tip').css({display:'block'})
    return
  }else{
    window.location.href = '/search/'+encodeURIComponent(query)
  }
}
/**
 * 列表模版
 * @param {*} arr 
*/
const FeedList = (arr,qutery) =>{
  arr.map(val =>{val.published_time = toDateList(val.published_time)})
  return new Promise(function (resolve, reject) {
    let str = "";
    for (let i = 0; i < arr.length; i++) {
      let sort_list = JSON.stringify(arr[i].sort_list)
      let new_title = letterLight(arr[i].news_title,qutery)
   
      str+=`<li sort='${sort_list}'>
          <a href="/n/${arr[i].news_id}" target="news">
            <figure class="flex-row-left">
                <div class="progressive figure-img">
                    <img class="preview lazy" onerror="onerror=null;src='https://s.laoyaoba.com/jiwei/weben/node-def_bg.jpg'" src="${arr[i].cover}?imageView2/2/w/200" data-src="${arr[i].cover}" alt="">
                  </div>
                <figcaption class="flex-column-space">
                    <h4 class="ell_three news_h4">${new_title}</h4>
                    <p class="ell_two">${arr[i].intro}</p>
                </figcaption>
            </figure>
            <div class="flex-row-space">
                <div></div>
                <div class="flex-row-left">
                  <div class="view_num"> `;
                    if (Math.trunc(Number(arr[i].view_num) / 10000) != 0) {
                      str += `<span class="red">${Math.floor(Number(arr[i].view_num)/10000 * 10) / 10 }w</span>
                            <img class="hot" src="https://s.laoyaoba.com/jiwei/weben/hot.png" alt="ijiwei" />`;
                    } else {
                      str += `<span>${arr[i].view_num}</span>
                            <img class="look" src="https://s.laoyaoba.com/jiwei/weben/look.png" alt="ijiwei" />`;
                    }
                    str +=  ` </div>
                  <div class="time color9">${arr[i].published_time}</div>
                
                </div>
              </div>
          </a>
      </li>`
      
    }
    resolve(str);
    
  })
}

/**
 * 列表数据
 * @param {*} query 
 * @param {*} searchAfter 
*/
const postFeed = () => {
  let searchAfter = $("#feed_list li:last").attr('sort')
  return new Promise(function (resolve, reject) {
    IndexModule.getFeedStream({
      category_id: 228,
      source: "pc",
      limit: 10,
      query: query,
      search_after: searchAfter
    }).then(res => {
      
      let { errno, data } = res.data;
      if (errno == 0) {
          resolve(data);
      } else {
          reject(res);
      }
    }).catch(error => {
      console.error(error);
    });
  })
}

/**
 * 加载更多
 */
let moreBtn = document.getElementById("moreBtn")
if(moreBtn){
  moreBtn.onclick = throttle(() => {
    if(moreBtn.innerText === 'NO MORE'){
      return
    }
    let qutery =$('#seaerch_val').val()
    postFeed().then(res =>{
      FeedList(res.list,qutery).then((str) =>{
        if (Object.keys(res.list).length == 0 || res.list.length < 10) {
          document.getElementById("moreBtn").style.display = "none";
        }else{
          document.getElementById("moreBtn").innerText = "MORE";
        }
        let feed_list = document.getElementById("feed_list");
        append(feed_list, str)
      })
    })
}, 1000)
}
/**
 * 实现拼接字符串
 * @param {*} parent 
 * @param {*} text 
 */
 const append = (parent, text) => {
  if (typeof text === 'string') {
      var temp = document.createElement('div');
      temp.innerHTML = text;
      // 防止元素太多 进行提速
      var frag = document.createDocumentFragment();
      while (temp.firstChild) {
          frag.appendChild(temp.firstChild);
      }
      parent.appendChild(frag);
  }
  else {
      parent.appendChild(text);
  }
}